import React from "react";
import {useLocation} from "react-router-dom";
import EmailPreview from "./EmailPreview";
import SmsPreview from "./SmsPreview";

function CampaignPreview() {
    let {state} = useLocation();
    //const { campaignId } = useParams();
    const getStatus = (id) => {
        let retVal = "";
        switch (id) {
            case 0:
                retVal = "Pending";
                break;
            case 1:
                retVal = "In Process";
                break;
            case 2:
                retVal = "Finished";
                break;
            case 3:
                retVal = "Error";
                break;
            default:
                retVal = "Unknown";
                break;
        }
        return retVal;
    };
    return (
        <>
            <div className="container container-xxl">
                <div className="pagetitle d-flex justify-content-between">
                    <h1>Preview Campaign</h1>
                </div>
                <div className="card">
                    <div className="card-body p-4">
                        <div className="d-flex justify-content-between">
                            <div className="d-flex flex-column">
                <span>
                  <strong>Clinic Name : </strong>
                    {state && state.info.clinicName}
                </span>
                                <span>
                  <strong>Name : </strong>
                                    {state && state.info.name}
                </span>
                                <span>
                  <strong>Title : </strong>
                                    {state && state.info.title}
                </span>
                            </div>
                            <div>
                <span>
                  <strong>
                    Current Status : {state && getStatus(state.info.status)}
                  </strong>
                </span>
                            </div>
                            <div className="d-flex flex-column">
                <span>
                  <strong>Id : </strong> {state && state.info.id}
                </span>
                                <span>
                  <strong>Type : </strong> {state && state.info.type}
                </span>
                                <span>
                  <strong>Category : </strong>
                                    {state && state.info.category}
                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        {state && state.info.type === "EMAIL" ? (
                            <EmailPreview id={state.info.id}/>
                        ) : (
                            <SmsPreview id={state.info.id}/>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default CampaignPreview;
